// cloud_RoleName for every nuxt4 App Insights row, server and browser, so
// queries and the application map can tell this app apart from nuxt2 ("Web")
// in the shared Website resources. Matches the Helm release / pod name. AB#63632
export const APP_INSIGHTS_ROLE_NAME = 'ordering-website'
